import React from 'react';
import { translate } from '../../../../utils/translator';

interface SparkleLabelProps {
  language: string;
  onClick?: () => void;
}

const SparkleLabel: React.FC<SparkleLabelProps> = ({ language, onClick }) => {
  const style: React.CSSProperties = {
        display: 'inline-block',
        marginLeft: '6px',
        fontWeight: 600,
        fontSize: '12px',
        backgroundColor: '#269C6E',
        color: '#ffffff',
        borderRadius: '4px',
        padding: '2px 8px',
        letterSpacing: '0.5px',
        position: 'relative',
    overflow: 'hidden',
  };
  if (onClick) {
    style.cursor = 'pointer';
  }
  const label = (
    <span style={style}>
      {translate(language, 'choose_treatment', 'default/label')}
      <span
        style={{
          position: 'absolute',
          top: 0,
          left: '-100%',
          width: '100%',
          height: '100%',
          background: 'linear-gradient(120deg, transparent 0%, transparent 35%, rgba(255, 255, 255, 0.6) 50%, transparent 65%, transparent 100%)',
          animation: 'shimmer 2s infinite',
        }}
      />
      <style>{`
        @keyframes shimmer {
          0% {
            left: -100%;
          }
          100% {
            left: 100%;
          }
        }
      `}</style>
    </span>
  );
  if (onClick) {
    return (
      <span
        role="button"
        tabIndex={0}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onClick();
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            e.stopPropagation();
            onClick();
          }
        }}
        style={{ padding: 0, border: 'none', background: 'none', cursor: 'pointer', display: 'inline-block' }}
        aria-label={translate(language, 'choose_treatment', 'default/label')}
      >
        {label}
      </span>
    );
  }
  return label;
};

export default SparkleLabel;
